export const QA_NAME_APPLICANT_PROFILE_WIDGET_ATTENTION =
  'applicantProfileWidgetAttention'

export const QA_NAME_APPLICANT_PROFILE_WIDGET_ATTENTION_ACTION =
  'applicantProfileWidgetAttentionAction'
